import {CSSProperties} from "react";

let React = require('react');
import reactCSS from 'reactcss'
import * as checkboard from '../../helpers/checkboard'

export const Checkboard = ({ white=undefined, grey=undefined, size=undefined, renderers=undefined, borderRadius=undefined, boxShadow=undefined }) => {
  const styles = {
      grid: {
        borderRadius,
        boxShadow,
        position:'absolute',
        top:0,
        left:0,
        right:0,
        bottom:0,
        background: `url(${ checkboard.get(white, grey, size, renderers.canvas) }) center left`,
      }};

  return (
    <div style={ styles.grid as CSSProperties } />
  )
}

Checkboard.defaultProps = {
  size: 8,
  white: 'transparent',
  grey: 'rgba(0,0,0,.08)',
  renderers: {},
}

export default Checkboard
